<router-outlet *ngIf="downtime"></router-outlet>
<ng-container *ngIf="!downtime">
    <div *ngIf="auth.csrfToken$ | async" fxLayout="column" class="main-container">
        <app-header></app-header>
        <app-maintenance-message></app-maintenance-message>
        <app-body fxFlex="1 0 auto"></app-body>
        <dsw-footer locale="de-DE" cookies></dsw-footer>
    </div>
</ng-container>
